import React from 'react'
import { FaCog, FaEdit, FaRegUser, FaTasks, FaThList } from 'react-icons/fa'
import config from '../../../config'

export const getAdminSection = ({ hasCustomer = false, hasUser = false, hasGC = false, hasRest = false }) => {
  const adminSectionLinks = []

  if (hasCustomer) {
    adminSectionLinks.push({
      name: 'Customer',
      path: '/admin/customers',
      icon: <FaEdit />,
    })
  }
  if (hasUser) {
    adminSectionLinks.push({
      name: 'User',
      path: '/admin/users',
      icon: <FaRegUser />,
    })
  }
  if (hasRest) {
    adminSectionLinks.push(
      {
        name: 'Application Category',
        path: '/admin/systemVariables/applicationCategory',
        icon: <FaCog />,
      },
      {
        name: 'Business Unit',
        path: '/admin/systemVariables/businessUnit',
        icon: <FaEdit />,
      },
      {
        name: 'Contributor Group',
        path: '/admin/contributorGroups',
        icon: <FaEdit />,
      },
      {
        name: 'Cost Centers',
        path: '/admin/costCenters',
        icon: <FaEdit />,
      },

      {
        name: 'Delegation',
        path: '/admin/delegations',
        icon: <FaEdit />,
      },
      {
        name: 'Template Management',
        path: '/admin/documentTemplates',
        icon: <FaEdit />,
      },
      {
        name: 'Team',
        path: '/admin/systemVariables/team',
        icon: <FaEdit />,
      },
      {
        name: 'GCK Code',
        path: '/admin/gckCodes',
        icon: <FaEdit />,
      },

      {
        name: 'Rule',
        path: '/admin/rules',
        icon: <FaEdit />,
      },
      {
        name: 'SISIC Code',
        path: '/admin/systemVariables/sisic',
        icon: <FaEdit />,
      },
      {
        name: 'SLA Template',
        path: '/admin/SLAs',
        icon: <FaEdit />,
      },

      {
        name: 'Vendor Category',
        path: '/admin/systemVariables/vendorCategory',
        icon: <FaEdit />,
      },

      {
        name: 'Table Profiles',
        path: '/admin/tableProfiles',
        icon: <FaEdit />,
      },

      {
        name: 'Frame Agreement',
        path: '/admin/frameAgreements',
        icon: <FaEdit />,
      }
    )
  }

  if (hasGC) {
    adminSectionLinks.push(
      {
        name: 'HS Code',
        path: '/admin/gc/hsCode',
        icon: <FaEdit />,
      },
      {
        name: 'GC Material',
        path: '/admin/GCMaterials',
        icon: <FaEdit />,
      },
      {
        name: 'ECCN',
        path: '/admin/eccn',
        icon: <FaEdit />,
      },
      {
        name: 'AL',
        path: '/admin/al',
        icon: <FaEdit />,
      },
      {
        name: 'ZZ6',
        path: '/admin/zzz6',
        icon: <FaEdit />,
      }
    )
  }

  return {
    title: 'Admin Management',
    defaultOpen: false,

    links: adminSectionLinks,
  }
}

export const adminConfigSection = {
  title: 'Config',
  defaultOpen: false,
  links: [
    {
      name: 'Offer Config',
      path: '/admin/configs/offer',
      icon: <FaCog />,
    },

    {
      name: 'Application Type',
      path: '/admin/applicationTypes',
      icon: <FaCog />,
    },
    {
      name: 'Announcement',
      path: '/admin/configs/announcement',
      icon: <FaCog />,
    },
    {
      name: 'User Manual',
      path: '/admin/configs/userManual',
      icon: <FaCog />,
    },
    {
      name: 'Testing Config',
      path: '/admin/configs/testing',
      icon: <FaCog />,
    },
    {
      name: 'Admin Function',
      path: '/admin/configs/adminFunction',
      icon: <FaCog />,
    },
    {
      name: 'Admin Email Function',
      path: '/admin/configs/adminEmailFunction',
      icon: <FaCog />,
    },
    {
      name: 'Close/Lost Reason',
      path: '/admin/configs/closeReasons',
      icon: <FaCog />,
    },
    {
      name: 'System Config',
      path: '/admin/configs/systemConfig',
      icon: <FaCog />,
    },
  ],
}

export const getAdminVendorSection = ({ hasUser = false, hasRest = false }) => {
  let vendorSectionLinks = []

  if (hasRest) {
    vendorSectionLinks = [
      {
        name: 'All Vendor',
        path: '/admin/vendors',
        icon: <FaCog />,
      },
      {
        name: 'Temporary Vendor',
        path: '/admin/vendors/temporary',
        icon: <FaRegUser />,
      },
    ]
  }

  if (hasUser) {
    vendorSectionLinks.push({
      name: 'Vendor User',
      path: '/admin/users/vendors',
      icon: <FaRegUser />,
    })
  }

  // Add Material RFQ link
  if (hasRest && config.allowMaterialRFQ) {
    vendorSectionLinks.push({
      name: 'Material RFQ',
      path: '/admin/materialRFQ',
      icon: <FaCog />,
    })
  }

  return {
    title: 'Vendor Quotation',
    defaultOpen: false,
    links: vendorSectionLinks,
  }
}

export const getOfferManagementSection = ({ hasMaintenance = false, hasProject = false, hasParticipation = true }) => {
  const offerSectionLinks = []

  return {
    title: 'Offer List Management',
    defaultOpen: false,

    links: offerSectionLinks,
  }
}

export const getOfferSection = ({
  hasMaintenance = false,
  hasProject = false,
  hasParticipation = true,
  profiles = [],
}) => {
  const childLinks = []

  const offerChildLinks = []
  const bookingChildLinks = []

  if (hasMaintenance) {
    offerChildLinks.push({
      name: 'Maintenance',
      path: '/offers/offerMaintenance',
      icon: <FaEdit />,
    })

    bookingChildLinks.push({
      name: 'Maintenance',
      path: '/offers/bookingMaintenance',
      icon: <FaEdit />,
    })
  }

  if (hasProject) {
    offerChildLinks.push({
      name: 'Project',
      path: '/offers/offerProject',
      icon: <FaEdit />,
    })

    bookingChildLinks.push({
      name: 'Project',
      path: '/offers/bookingProject',
      icon: <FaEdit />,
    })
  }

  if (hasMaintenance || hasProject) {
    const eQuotationChildLinks = [
      {
        name: 'eQuotation - End Customer',
        path: '/offers/offerEQuotationEndCustomer',
        icon: <FaEdit />,
      },
      {
        name: 'eQuotation - Tenant',
        path: '/offers/offerEQuotationTenant',
        icon: <FaEdit />,
      },
      {
        name: 'eQuotation - Product',
        path: '/offers/offerEQuotationProduct',
        icon: <FaEdit />,
      },
    ]

    const bookingEQuotationChildLinks = [
      {
        name: 'eQuotation - End Customer',
        path: '/offers/bookingEQuotationEndCustomer',
        icon: <FaEdit />,
      },
      {
        name: 'eQuotation - Tenant',
        path: '/offers/bookingEQuotationTenant',
        icon: <FaEdit />,
      },
      {
        name: 'eQuotation - Product',
        path: '/offers/bookingEQuotationProduct',
        icon: <FaEdit />,
      },
    ]

    offerChildLinks.push({
      name: 'eQuotation',
      path: '',
      icon: <FaEdit />,
      childLinks: eQuotationChildLinks,
    })

    bookingChildLinks.push({
      name: 'eQuotation',
      path: '',
      icon: <FaEdit />,
      childLinks: bookingEQuotationChildLinks,
    })
  }

  const profileLinks = profiles.map((profile) => {
    return {
      name: 'Profile - ' + profile.profileName,
      path: '/offers/my?profileId=' + profile._id,
      icon: <FaEdit />,
    }
  })

  const offerSectionLinks = [
    {
      name: 'My Tasks',
      path: '/offers/tasks',
      icon: <FaTasks />,
    },
    {
      name: 'My Profiles',
      path: '',
      icon: <FaEdit />,
      childLinks: profileLinks,
    },

    {
      name: 'Offer',
      path: '',
      icon: <FaEdit />,
      childLinks: offerChildLinks,
    },
    {
      name: 'Booking',
      path: '',
      icon: <FaEdit />,
      childLinks: [...bookingChildLinks],
    },
    {
      name: 'Maintenance Summary',
      path: '/offers/maintenanceSummary',
      icon: <FaEdit />,
    },
    {
      name: 'Sourcing',
      path: '',
      icon: <FaEdit />,
      childLinks: [
        {
          name: 'Sourcing Decisions',
          path: '/offers/sourcingDecisions', //A new term to identify offer for TA & enginner
          icon: <FaEdit />,
        },
        {
          name: 'Vendor RFQs',
          path: '/offers/vendorRFQs', //A new term to identify offer for TA & enginner
          icon: <FaEdit />,
        },
        // {
        //   name: 'Frame Contracts',
        //   path: '', //A new term to identify offer for TA & enginner
        //   icon: <FaEdit />,
        // },
      ],
    },
  ]

  return {
    title: 'Offer Management',
    defaultOpen: false,
    links: offerSectionLinks,
  }
}

export const getSourcingOfferSection = ({ profiles = [] }) => {
  return {
    title: 'Offer Management',
    defaultOpen: false,
    links: [
      {
        name: 'My Tasks',
        path: '/offers/tasks',
        icon: <FaTasks />,
      },
      {
        name: 'Sourcing',
        path: '',
        icon: <FaEdit />,
        childLinks: [
          {
            name: 'Sourcing Decisions',
            path: '/offers/sourcingDecisions', //A new term to identify offer for TA & enginner
            icon: <FaEdit />,
          },
          {
            name: 'Vendor RFQs',
            path: '/offers/vendorRFQs', //A new term to identify offer for TA & enginner
            icon: <FaEdit />,
          },
          ...profiles.map((profile) => {
            return {
              name: 'Profile - ' + profile.profileName,
              path: '/offers/mySourcing?profileId=' + profile._id,
              icon: <FaEdit />,
            }
          }),
          // {
          //   name: 'Frame Contracts',
          //   path: '', //A new term to identify offer for TA & enginner
          //   icon: <FaEdit />,
          // },
        ],
      },
    ],
  }
}

export const applicationSection = {
  title: 'Applications',
  defaultOpen: false,
  links: [
    {
      name: 'My Applications',
      path: '/applications',
      icon: <FaEdit />,
    },
    {
      name: 'Application Approvals',
      path: '/applications/approvals',
      icon: <FaEdit />,
    },
  ],
}

export const dashboardSection = {
  title: 'Dashboard',
  defaultOpen: false,
  links: [
    {
      name: 'Dashboard Team 1',
      path: '/dashboard',
      icon: <FaEdit />,
    },
  ],
}
